import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Marquee = ({ items, className = "" }) => {
  const row = [...items, ...items];
  return (
    <div className={`overflow-hidden whitespace-nowrap ${className}`} data-testid="editorial-marquee">
      <div className="js-marquee-track inline-flex items-baseline">
        {row.map((item, i) => (
          <span key={i} className="inline-flex items-baseline">
            <span className="font-display text-2xl sm:text-3xl tracking-tight px-10 sm:px-16">{item}</span>
            <span className="font-mono text-xs tracking-[0.3em] opacity-50">·</span>
          </span>
        ))}
      </div>
    </div>
  );
};

export const Overline = ({ children, dark = false }) => (
  <p
    className={`font-mono text-[11px] uppercase tracking-[0.28em] ${
      dark ? "text-white/50" : "text-black/45"
    }`}
  >
    {children}
  </p>
);
